// components/authStorage.js
import { isPlatform } from '@ionic/react';
import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = process.env.REACT_APP_JWT_STORAGE_KEY || 'accessToken';
const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refreshToken';

export const setToken = async (token) => {
  if (isPlatform('capacitor')) {
    await Preferences.set({ key: TOKEN_KEY, value: token });
  } else {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

export const getToken = async () => {
  if (isPlatform('capacitor')) {
    const { value } = await Preferences.get({ key: TOKEN_KEY });
    return value;
  } else {
    return localStorage.getItem(TOKEN_KEY);
  }
};

export const removeToken = async () => {
  if (isPlatform('capacitor')) {
    await Preferences.remove({ key: TOKEN_KEY });
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};
// Guarda el refresh token
export const setRefreshToken = async (token) => {
  if (isPlatform('capacitor')) {
    await Preferences.set({ key: REFRESH_TOKEN_KEY, value: token });
  } else {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }
};

// Obtiene el refresh token
export const getRefreshToken = async () => {
  if (isPlatform('capacitor')) {
    const { value } = await Preferences.get({ key: REFRESH_TOKEN_KEY });
    return value;
  } else {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }
};

// Elimina el refresh token
export const removeRefreshToken = async () => {
  if (isPlatform('capacitor')) {
    await Preferences.remove({ key: REFRESH_TOKEN_KEY });
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

// Limpia todos los tokens (access y refresh)
export const clearAllTokens = async () => {
  await removeToken();
  await removeRefreshToken();
  
  // También limpiar datos de usuario del localStorage para compatibilidad
  if (!isPlatform('capacitor')) {
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
  }
};